export const projects = [
  {
    title: "Stambeni kompleks Dunavske Terase",
    location: "Novi Beograd",
    type: "Stanovanje",
    description: "Kompletan sistem video nadzora i kontrole pristupa za luksuzni stambeni kompleks sa 200 stanova. Instalirano 64 IP kamere, 12 RFID kontrolera i integrisani sistem video interfona.",
    stats: [
      { value: "64", label: "IP kamera" },
      { value: "12", label: "RFID kontrolera" },
      { value: "200", label: "Stanova" },
    ],
    image: "https://readdy.ai/api/search-image?query=Luxury%20modern%20residential%20apartment%20complex%20exterior%20with%20landscaping%2C%20contemporary%20architecture%20with%20glass%20balconies%2C%20clean%20urban%20design%2C%20bright%20natural%20daylight%2C%20premium%20real%20estate%20development&width=800&height=600&seq=project-dunavske&orientation=landscape",
  },
  {
    title: "TechPark Office Centar",
    location: "Novi Sad",
    type: "Poslovni prostor",
    description: "Sistem kontrole pristupa i video nadzora za poslovni centar sa preko 100 zaposlenih. Implementirana AI analitika za detekciju lica i integracija sa parking sistemom.",
    stats: [
      { value: "32", label: "IP kamera" },
      { value: "1,200", label: "RFID kartica" },
      { value: "4", label: "Sprata" },
    ],
    image: "https://readdy.ai/api/search-image?query=Modern%20glass%20office%20building%20exterior%20with%20professional%20corporate%20design%2C%20blue%20sky%20reflection%20on%20windows%2C%20urban%20business%20center%20architecture%2C%20daytime%20professional%20photography&width=800&height=600&seq=project-techpark&orientation=landscape",
  },
  {
    title: "Retail Park Niš",
    location: "Niš",
    type: "Maloprodaja",
    description: "Video nadzor i AI analitika za retail park sa 15 prodavnica. Sistem prati protok ljudi, detektuje sumnjivo ponašanje i integriše se sa POS sistemima zakupaca.",
    stats: [
      { value: "48", label: "IP kamera" },
      { value: "15", label: "Prodavnica" },
      { value: "-60%", label: "Gubici" },
    ],
    image: "https://readdy.ai/api/search-image?query=Modern%20outdoor%20retail%20shopping%20center%20with%20stores%2C%20clean%20contemporary%20architecture%2C%20bright%20sunny%20day%20with%20blue%20sky%2C%20commercial%20retail%20park%20aesthetic&width=800&height=600&seq=project-retail-park&orientation=landscape",
  },
];

export const clientsLogo = [
  { name: "Dunavske Terase", icon: "ri-building-line" },
  { name: "TechPark NS", icon: "ri-building-2-line" },
  { name: "Retail Park Niš", icon: "ri-store-2-line" },
  { name: "Lux Apartmani BG", icon: "ri-hotel-line" },
  { name: "Delta Holding", icon: "ri-building-3-line" },
];